import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NavDrawer from "./NavDrawer";
import i18next from "i18next";
import { Pages } from "../../constants";
import { BasicSelect as TransLang } from "./TransLang";

function NavBar({ data }) {
    let lng = i18next.language;
    const [drawer, setDrawer] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
    const general = data?.general || {};
    const logoUrl = general?.image;

    return (
        <>
            <AppBar
                position="fixed"
                elevation={0}
                sx={{
                    top: 0,
                    left: 0,
                    right: 0,
                    bgcolor: "transparent",
                    zIndex: 99,
                    pointerEvents: "none",
                    pt: { xs: 2, md: 3 },
                }}>
                <Toolbar
                    disableGutters
                    sx={{
                        mx: "auto",
                        width: "calc(100% - 48px)",
                        maxWidth: "1400px",
                        px: { xs: 2, md: 4 },
                        minHeight: { xs: 70, md: 80 },
                        bgcolor: "rgba(10, 25, 47, 0.4)",
                        border: "1px solid rgba(255, 255, 255, 0.04)",
                        borderRadius: "20px",
                        backdropFilter: "blur(12px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        pointerEvents: "auto",
                        transition: "all 0.3s ease",
                        ...(scrolled && {
                            bgcolor: "rgba(6, 15, 30, 0.85)",
                            boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.4)",
                            mt: -1,
                        })
                    }}
                >
                    <Box
                        sx={{
                            display: { md: "flex", xs: "none" },
                            alignItems: "center",
                            gap: 4,
                            flexGrow: 1,
                            justifyContent: "space-between",
                        }}
                    >
                        <Link to="/" onClick={scrollToTop} style={{ textDecoration: "none" }}>
                            {logoUrl ? (
                                <Box
                                    component="img"
                                    src={logoUrl}
                                    alt="logo"
                                    sx={{ height: 50, width: "auto", display: "block", filter: "drop-shadow(1px 1px 0 rgba(94,176,255,0.9)) drop-shadow(-1px -1px 0 rgba(94,176,255,0.9)) drop-shadow(1px -1px 0 rgba(94,176,255,0.9)) drop-shadow(-1px 1px 0 rgba(94,176,255,0.9))" }}
                                />
                            ) : (
                                <Box sx={{ color: "#F8FAFC", fontWeight: 700, fontSize: 22 }}>
                                    {general?.site_name?.[lng] || general?.site_name?.en || "ARAM MARKETING"}
                                </Box>
                            )}
                        </Link>

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: { md: 4, lg: 5 },
                                flexWrap: "wrap",
                            }}
                        >
                            {Pages?.map((page, i) => (
                                <NavLink
                                    key={i}
                                    to={page.path}
                                    onClick={scrollToTop}
                                    style={({ isActive }) => ({
                                        textDecoration: "none",
                                        fontSize: 15,
                                        fontWeight: isActive ? 700 : 500,
                                        color: isActive ? "#5EB0FF" : "#E5E7EB",
                                        padding: "8px 0",
                                        position: "relative",
                                        transition: "color 0.2s",
                                    })}
                                >
                                    {lng === "ar" ? page.name : page.name_en}
                                    {/* Active Indicator */}
                                    {/* <Box
                                        component="span"
                                        sx={{
                                            position: "absolute",
                                            bottom: 0,
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            width: (theme) => isActive ? "100%" : "0%",
                                            height: "2px",
                                            bgcolor: "#5EB0FF",
                                            transition: "width 0.3s ease",
                                        }}
                                    /> */}
                                </NavLink>
                            ))}
                        </Box>
                        <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", gap: 2 }}>
                            <TransLang />
                        </Box>
                    </Box>


                    <Box
                        sx={{
                            display: { md: "none", xs: "flex" },
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            gap: 2,
                        }}
                    >
                        <Link to="/" onClick={scrollToTop} style={{ textDecoration: "none" }}>
                            {logoUrl ? (
                                <Box
                                    component="img"
                                    src={logoUrl}
                                    alt="logo"
                                    sx={{ height: 44, width: "auto", filter: "drop-shadow(1px 1px 0 rgba(94,176,255,0.9)) drop-shadow(-1px -1px 0 rgba(94,176,255,0.9)) drop-shadow(1px -1px 0 rgba(94,176,255,0.9)) drop-shadow(-1px 1px 0 rgba(94,176,255,0.9))" }}
                                />
                            ) : (
                                <Box sx={{ color: "#F8FAFC", fontWeight: 700, fontSize: 18 }}>
                                    {general?.site_name?.[lng] || general?.site_name?.en || "ARAM MARKETING"}
                                </Box>
                            )}
                        </Link>

                        <IconButton onClick={() => setDrawer(true)} sx={{ color: "#F8FAFC" }}>
                            <MenuIcon sx={{ fontSize: "1.85rem" }} />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            <NavDrawer drawer={drawer} setDrawer={setDrawer} logoUrl={logoUrl} pages={Pages} />
        </>
    );
}

export default NavBar;
